// removed by extract-text-webpack-plugin
module.exports = {"add-address-link":"_1Mnh9hpmy_Ci2-s_ElZU-A","button-bar":"wvmhbHIGhl0xMnpoSMdMT"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/AddressBook/components/AddressBookIndex/style.scss
// module id = 924
// module chunks = 0